import { useEffect, useMemo, useState } from 'react';
import { throttle } from 'lodash';

const breakpoints = [
  { label: 'sm', size: 640 },
  { label: 'md', size: 768 },
  { label: 'lg', size: 1024 },
  { label: 'xl', size: 1280 },
  { label: '2xl', size: 1536 },
];

type Breakpoint = {
  label: string;
  size: number;
};

const getDeviceConfig = (width: number): string => {
  let output: string | undefined;

  breakpoints.every(({ label, size }: Breakpoint) => {
    if (width < size) {
      output = label;
      return false;
    } else {
      return true;
    }
  });

  return output ?? breakpoints[breakpoints.length - 1].label;
};

type UseBreakpointReturn = {
  breakpoint: string | undefined;
  isMobile: boolean;
};

export const useBreakpoint = (): UseBreakpointReturn => {
  const [breakpoint, setBreakpoint] = useState<string>('');

  const isMobile = useMemo(() => ['md', 'sm'].includes(breakpoint), [breakpoint]);

  const throttledCalcInnerWidth = useMemo(() => {
    const calcInnerWidth = () => {
      setBreakpoint(getDeviceConfig(window.innerWidth));
    };
    return throttle(() => calcInnerWidth(), 200);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', throttledCalcInnerWidth);
    const timeout = setTimeout(throttledCalcInnerWidth, 0);

    return () => {
      clearTimeout(timeout);
      window.removeEventListener('resize', throttledCalcInnerWidth);
    };
  }, [throttledCalcInnerWidth]);

  return { breakpoint, isMobile };
};
